import { Grid } from "antd";
import { withConditionalComponent } from "src/HOC/WithMobileComponent";
import GiftcardInstructionsWeb from "./layouts/GiftcardInstructions.web";
import GiftcardInstructionsMob from "./layouts/GiftcardInstructions.mob";
import { MOBILE_BREAKPOINT_KEY } from "src/constants";
import { FC, useState } from "react";
import { HOW_TO_USE_KEY } from "../../../../constants";

const GiftcardInstructionsComponent = withConditionalComponent(GiftcardInstructionsWeb, GiftcardInstructionsMob);

type Props = {
  usageInstructions: string;
  termsAndCondition: string;
};

const GiftcardInstructions: FC<Props> = ({ usageInstructions, termsAndCondition }) => {
  const isLargeScreen = !!Grid.useBreakpoint()[MOBILE_BREAKPOINT_KEY];
  const [activeKey, setActiveKey] = useState(HOW_TO_USE_KEY);

  return (
    <GiftcardInstructionsComponent
      trigger={isLargeScreen}
      props={{
        usageInstructions,
        termsAndCondition,
        activeKey,
        onChange: (key: string | string[]) => setActiveKey(Array.isArray(key) ? key[0] : key),
      }}
    />
  );
};

export default GiftcardInstructions;
